import styled from 'styled-components'

const MakeVideo = styled.section`
	--videoWrapMTop: var(--sp9x);
	--videoHeight: 55.3%;

	margin-top: var(--sectionDistance);

	.make-video-container {
		margin-top: var(--videoWrapMTop);

		.make-video-wrapper {
			position: relative;
			pointer-events: none;

			* {
				cursor: none;
			}

			.video-cont {
				pointer-events: all;
				padding-top: var(--videoHeight);
			}

			.play-and-pause-cursor-wrap {
				position: absolute;
				z-index: 3;
				pointer-events: none;
				transform: scale(0);

				@media (hover: none) {
					display: none;
				}

				.play-and-pause-cursor {
					position: absolute;
					top: 0;
					left: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					width: var(--playPauseCursorSize);
					height: var(--playPauseCursorSize);
					border-radius: 50%;
					font-size: var(--h4);
					color: var(--bodyColor);
					background-color: var(--primaryColor9);
					transform: translate(-50%, -50%);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--videoWrapMTop: var(--sp7x);
		--videoHeight: 55%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--videoWrapMTop: var(--sp6x);
		--videoHeight: 54.9%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--videoWrapMTop: var(--sp5x);
		--videoHeight: 54.6%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--videoWrapMTop: var(--sp5x);
		--videoHeight: 54.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--videoWrapMTop: var(--sp5x);
		--videoHeight: 54.4%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--videoWrapMTop: var(--sp5x);
		--videoHeight: 53.7%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--videoWrapMTop: var(--sp4x);
		--videoHeight: 50.9%;

		.comp-title {
			text-align: left;
		}
	}
`

export default MakeVideo
